import React, { useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Typography,
} from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { LAMBDA_BASE_URL } from "../../constants";

const ExcludeDomain: React.FC = () => {
  const [searchParams] = useSearchParams();
  const excludeDomain = searchParams.get("excludeDomain");

  const { mutate, isPending, isError, error } = useMutation({
    mutationFn: (domain: string) =>
      axios.post(LAMBDA_BASE_URL, { excludeDomain: domain }),
  });

  useEffect(() => {
    if (excludeDomain) {
      mutate(excludeDomain);
    }
  }, [excludeDomain, mutate]);

  return excludeDomain ? (
    isPending ? (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          gap: 2,
          height: 300,
        }}>
        <CircularProgress />
      </Box>
    ) : (
      <Card elevation={5} sx={{ width: 500, margin: "auto" }}>
        <CardContent>
          <Container maxWidth='sm' sx={{ mt: 8 }}>
            <Typography variant='h5'>
              ✅ Excluded domain: <b>{excludeDomain}</b>
            </Typography>
            <Typography variant='body1' sx={{ mt: 2 }}>
              We have successfully excluded the domain from automatic email
              syncing.
            </Typography>
            <Typography variant='body2' sx={{ mt: 2 }}>
              Jarvis will no longer sync emails from this domain.
            </Typography>
            {isError && (
              <Typography variant='body1' color='error' mt='8px'>
                ❌ An error occurred while excluding the domain.
                <br />
                {error.message || "Please try again later."}
              </Typography>
            )}
          </Container>
        </CardContent>
      </Card>
    )
  ) : (
    <h1>No domain to exclude provided</h1>
  );
};

export default ExcludeDomain;
